<template>
  <el-dialog :title="isAdd ? '新增数据字典' : '编辑数据字典'" :visible.sync="viewVisible" width="650px" :before-close="handleClose" :close-on-click-modal="false" center>
    <div class="from-body">
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="auto">
        <el-form-item label="协议名称" prop="protocolName">
          <el-input v-model="ruleForm.protocolName"  :disabled="true"/>
        </el-form-item>
        <el-form-item label="字典名称" prop="name">
          <el-input v-model="ruleForm.name" @input="onInput"/>
        </el-form-item>
        <el-form-item label="中文显示" prop="chinese">
          <el-input v-model="ruleForm.chinese" @input="onInput"/>
        </el-form-item>
        <el-form-item label="英文显示" prop="english">
          <el-input v-model="ruleForm.english" @input="onInput"/>
        </el-form-item>
        <el-form-item label="数据单位" prop="unit">
          <el-input v-model="ruleForm.unit" @input="onInput"/>
        </el-form-item>
        <el-form-item label="读写属性" prop="readWrite">
          <el-select v-model="ruleForm.readWrite" placeholder="请选择" @input="onInput" style="width:400px;">
            <el-option label="可读" :value=10 />
            <el-option label="可写" :value=20 />
            <el-option label="可读可写" :value=30 />
          </el-select>
        </el-form-item>
        <el-form-item label="谁能设置" prop="userEdit">
          <el-select v-model="ruleForm.userEdit" placeholder="请选择" @input="onInput" style="width:400px;" clearable>
            <el-option label="用户可设置" :value=10 />
            <el-option label="工程可设置" :value=20 />
            <el-option label="都不可设置" :value=30 />
          </el-select>
        </el-form-item>
        <el-form-item label="数据范围" prop="fanwei">
          <el-input v-model="ruleForm.fanwei" @input="onInput" placeholder="用~分隔表示连续范围，分号分隔表示可选值"/>
        </el-form-item>
        <el-form-item label="显示顺序" prop="position">
          <el-input v-model="ruleForm.position" @input="onInput"/>
        </el-form-item>
        <el-form-item label="分组名称" prop="groupName">
          <el-input v-model="ruleForm.groupName" @input="onInput"/>
        </el-form-item>
        <el-form-item label="图标路径" prop="iconPth">
          <el-input v-model="ruleForm.iconPth" @input="onInput"/>
        </el-form-item>
        <el-form-item label="首页参数" prop="homeFlag">
          <el-select v-model="ruleForm.homeFlag" placeholder="请选择" @input="onInput" style="width:400px;">
            <el-option label="是" :value=10 />
            <el-option label="不是" :value=20 />
          </el-select>
        </el-form-item>
        <el-form-item label="数据曲线" prop="chartFlag">
          <el-select v-model="ruleForm.chartFlag" placeholder="请选择" @input="onInput" style="width:400px;">
            <el-option label="显示" :value=10 />
            <el-option label="不显示" :value=20 />
          </el-select>
        </el-form-item>
        <el-form-item label="用户查看" prop="userFlag">
          <el-select v-model="ruleForm.userFlag" placeholder="请选择" @input="onInput" style="width:400px;">
            <el-option label="允许" :value=10 />
            <el-option label="不允许" :value=20 />
          </el-select>
        </el-form-item>
        <el-form-item label="是否故障" prop="faultFlag">
          <el-select v-model="ruleForm.faultFlag" placeholder="请选择" @input="onInput" style="width:400px;">
            <el-option label="是" :value=10 />
            <el-option label="不是" :value=20 />
          </el-select>
        </el-form-item>
        <el-form-item label="故障等级" prop="faultLevel">
          <el-select v-model="ruleForm.faultLevel" placeholder="请选择" @input="onInput" style="width:400px;" clearable>
            <el-option label="轻微" :value=10 />
            <el-option label="一般" :value=20 />
            <el-option label="严重" :value=30 />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button :style="{ color: buttonTextColor }" @click="handleClose">取 消</el-button>
      <el-button :style="{ color: buttonTextColor }" type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>


<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      ruleForm: {
        id: null,
        protocol: null,
        unit: null,
        name: "",
        chinese: "",
        english: "",
        readWrite: 10,
        userEdit: 30,
        position: 0,
        fanwei: null,
        protocolName: "",
        groupName: "",
        iconPth: "",
        homeFlag: 20,
        userFlag: 10,
        faultFlag: 20,
        faultLevel: null
      },
      rules: {
        name: [
          {
            required: true,
            message: "请填写数据名称",
            trigger: "blur",
          },
        ]
      },
    };
  },
  watch: {
    viewVisible(newVal) {
      if (newVal) {
        //新增
        if (this.isAdd) {
            this.ruleForm.id = null;
            this.ruleForm.protocol = this.protocol;
            this.ruleForm.unit = null;
            this.ruleForm.name = "";
            this.ruleForm.chinese = "";
            this.ruleForm.english = "";
            this.ruleForm.readWrite=10;
            this.ruleForm.userEdit=30;
            this.ruleForm.chartFlag=20;
            this.ruleForm.userFlag=10;
            this.ruleForm.position=0;
            this.ruleForm.groupName=null;
            this.ruleForm.fanwei=null;
            this.ruleForm.iconPth=null;
            this.ruleForm.homeFlag=20;
            this.ruleForm.faultFlag=20;
            this.ruleForm.faultLevel=null;
        } else {
          //修改
          this.ruleForm.id = this.currentData.id;
          this.ruleForm.protocol = this.currentData.protocol;
          this.ruleForm.unit = this.currentData.unit;
          this.ruleForm.name = this.currentData.name;
          this.ruleForm.chinese = this.currentData.chinese;
          this.ruleForm.english = this.currentData.english;
          this.ruleForm.readWrite = this.currentData.readWrite;
          this.ruleForm.userEdit = this.currentData.userEdit;
          this.ruleForm.position = this.currentData.position;
          this.ruleForm.groupName = this.currentData.groupName;
          this.ruleForm.fanwei = this.currentData.fanwei;
          this.ruleForm.iconPth = this.currentData.iconPth;
          this.ruleForm.homeFlag = this.currentData.homeFlag;
          this.ruleForm.userFlag = this.currentData.userFlag;
          this.ruleForm.chartFlag = this.currentData.chartFlag;
          this.ruleForm.faultFlag = this.currentData.faultFlag;
          this.ruleForm.faultLevel = this.currentData.faultLevel;
        }
        this.protocolInfo();
      }
    },
  },
  computed: {
    ...mapState(["buttonTextColor"]),
  },
  props: ["viewVisible","currentData","isAdd","protocol"],
  methods: {
    protocolInfo() {
      var params={
        "id": this.protocol
      };
      this.request.protocolInfo(params).then((res) => {
        if (res.code==0) {
         this.ruleForm.protocolName=res.data['name']+" | "+res.data['codec'];
         this.$forceUpdate();
        }
      });
    },
    onInput() {
      //input输入框无法编辑
      this.$forceUpdate();
    },
    handleClose() {
      this.ruleForm = {
        id: null,
        protocol: null,
        unit: null,
        name: "",
        chinese: "",
        english: "",
        readWrite: null,
        userEdit: 30,
        userFlag: 10,
        position: 0,
        groupName: null,
        fanwei: null,
        faultFlag: 10,
        chartFlag: 20,
        faultLevel: null
      };
      this.$refs["ruleForm"].resetFields();
      this.$emit("viewClose");
    },
    //提交
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            this.request.productDictionaryAdd(this.ruleForm).then((res) => {
              if (res.code==0) {
                this.$message.success("新增成功");
                this.$emit("productDictionaryList");
                this.handleClose();
              }
            });
          } else {
            this.request.productDictionaryEdit(this.ruleForm).then((res) => {
              if (res.code==0) {
                this.$message.success("编辑成功");
                this.$emit("productDictionaryList");
                this.handleClose();
              }
            });
          }
        }
      });
    },
  },
};
</script>


<style scoped>
.from-body {
  padding: 0 60px;
  box-sizing: border-box;
}
</style>